import React, { Fragment } from "react";
import {
  Table,
  TableHeader,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  NoDataFound,
} from "../../../../../components/table/tableComponent";
import DefaultInput from "../../../../../components/inputs/defaultInput";
import TableSkeleton from "../../../../../components/skeleton/tableSkeleton";
import { dateFormat } from "../../../../../../utils/helper";
import { DefaultImageView } from "../../../../../components/avatar/defaultAvatar";

const TableHeaderData = [
  "Employee",
  "Date of Joining",
  "Basic Salary",
  "Transport Allowance",
  "Special Allowance",
  "Net Salary",
];

const SalaryTable = ({
  tableData = [],
  loading = true,
  search = "",
  updateSallery = () => {},
}) => {
  return (
    <div className="flex flex-col gap-2">
      <Fragment>
        <Table className="shadow-md">
          <TableHeader>
            <TableRow>
              {TableHeaderData.map((header, index) => (
                <TableHead key={index}>{header}</TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            {loading ? (
              <TableSkeleton colSpan={TableHeaderData.length} />
            ) : (
              <>
                {tableData.length > 0 ? (
                  tableData.map((item, i) => (
                    <TableRow key={i}>
                      <TableCell>
                        <div className="flex justify-start gap-2 items-center">
                          <DefaultImageView
                            image={item.profile_image}
                            name={item.name}
                          />
                          {item.name}
                        </div>
                      </TableCell>
                      <TableCell>
                        {item.doj ? dateFormat(item.doj) : "-"}
                      </TableCell>
                      <TableCell>
                        <DefaultInput
                          value={item.basic_salary}
                          type="number"
                          placeholder="000.00"
                          onChange={(e) =>
                            updateSallery(
                              item.id,
                              "basic_salary",
                              e.target.value
                            )
                          }
                        />
                      </TableCell>
                      <TableCell>
                        <DefaultInput
                          value={item.transport_allowance}
                          type="number"
                          placeholder="500.00"
                          onChange={(e) =>
                            updateSallery(
                              item.id,
                              "transport_allowance",
                              e.target.value
                            )
                          }
                        />
                      </TableCell>
                      <TableCell>
                        <DefaultInput
                          value={item.special_allowance}
                          type="number"
                          placeholder="000.00"
                          onChange={(e) =>
                            updateSallery(
                              item.id,
                              "special_allowance",
                              e.target.value
                            )
                          }
                        />
                      </TableCell>
                      <TableCell>
                        <DefaultInput
                          readOnly={true}
                          value={item.net_salary}
                          type="number"
                          placeholder="000.00"
                          // onChange={(e) =>
                          //   updateSallery(item.id, "net_salary", e.target.value)
                          // }
                        />
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <NoDataFound
                      colSpan={TableHeaderData.length}
                      search={search}
                      text="No Data Found!"
                    />
                  </TableRow>
                )}
              </>
            )}
          </TableBody>
        </Table>
      </Fragment>
    </div>
  );
};

export default SalaryTable;
